// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/datatable-common-styles.less
// module id = 7
// module chunks = 1